/* eslint-disable */
export default {
  _asapregular: 'asapregular',
  _fontBold: 'fontBold',
}